export default [
  {
    path: "/bulktransfers",
    component: () => import(/* webpackChunkName: "transfers" */ "./layout"),

    children: [
      {
        path: "/",
        name: "bulktransfers.index",
        component: () => import(/* webpackChunkName: "transfers.index" */ "./all"),
      },

      {
        props: true,
        path: ":id",
        name: "bulktransfers.show",
        component: () => import(/* webpackChunkName: "transfers.show" */ "./show"),
      },
    ],
  },
];
